import { render, staticRenderFns } from "./c_user_navbar.vue?vue&type=template&id=19231150&scoped=true"
import script from "./c_user_navbar.vue?vue&type=script&lang=js"
export * from "./c_user_navbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19231150",
  null
  
)

export default component.exports